import React from "react";
import intl from 'react-intl-universal';
import classNames from "classnames";
import { Button } from "antd";
import "./widgets.scss";

export function SendButton({
    disabled,
    text,
    loading,
    onClick,
    className
}: {
    disabled: boolean;
    onClick: () => any;
    loading?: boolean;
    text?: string;
    className?: string;
}) {
    return (
        <Button
            className={classNames("dd-share__widget-btn", className)}
            type="primary"
            shape="round"
            loading={loading}
            disabled={disabled}
            onClick={onClick}
        >{text || intl.get('shareDlg.ShareWithEmail.sendBtnText')}</Button>
    )
}
